import React, { ReactNode } from 'react'
import NextLink from 'next/link'

import { StyledLink, SvgWrapper } from './Link.styles'

export const LINK_SIZES = ['large', 'medium', 'small'] as const
export type LinkSizes = (typeof LINK_SIZES)[number]

export type LinkProps = React.ComponentProps<typeof NextLink> & {
  icon?: ReactNode
  size?: LinkSizes
  children?: ReactNode | ReactNode[]
}

export const Link = ({ children, href, icon, size = 'medium', ...props }: LinkProps) => (
  // @ts-expect-error There is an issue with NextLink, and forwarding the typing for props
  <StyledLink href={href} size={size} icon={icon} {...props}>
    {icon && <SvgWrapper size={size}>{icon}</SvgWrapper>}
    {children}
  </StyledLink>
)
